import { collection, query, where, getDocs, addDoc, updateDoc, doc, deleteDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { COLLECTIONS } from '../../constants/collections';

// Standardize or assume this constant in collections.js if not present
const DOCK_COLLECTION = COLLECTIONS.DOCKS || 'docks';

const getCollectionPath = (tenantId) => `tenants/${tenantId}/${DOCK_COLLECTION}`;

export const getAllDocks = async (tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const q = query(
            collection(db, getCollectionPath(tenantId))
        );
        const snapshot = await getDocs(q);

        const docks = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        return docks.sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { numeric: true, sensitivity: 'base' }));
    } catch (error) {
        console.error('Error fetching docks:', error);
        return [];
    }
};

export const createDock = async (dockData, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const docRef = await addDoc(collection(db, getCollectionPath(tenantId)), {
            ...dockData,
            tenantId,
            createdAt: Timestamp.now(),
            updatedAt: Timestamp.now(),
            isActive: true
        });
        return docRef.id;
    } catch (error) {
        console.error('Error creating dock:', error);
        throw error;
    }
};

export const updateDock = async (dockId, updates, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        await updateDoc(doc(db, getCollectionPath(tenantId), dockId), {
            ...updates,
            updatedAt: Timestamp.now()
        });
    } catch (error) {
        console.error('Error updating dock:', error);
        throw error;
    }
};

export const deleteDock = async (dockId, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        await deleteDoc(doc(db, getCollectionPath(tenantId), dockId));
    } catch (error) {
        console.error('Error deleting dock:', error);
        throw error;
    }
};

export const getDocksByDoorGroup = async (doorGroupId, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const q = query(
            collection(db, getCollectionPath(tenantId)),
            where('doorGroupId', '==', doorGroupId)
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error('Error fetching docks by group:', error);
        return [];
    }
};
